import { withAdaptiveRender } from "../../utils/hoc/withAdaptiveRender";
import { DesktopFooter } from "./DesktopFooter";
import { MobileFooter } from "./MobileFooter";

export const Footer = withAdaptiveRender({
  desktop: DesktopFooter,
  tablet: DesktopFooter,
  mobile: MobileFooter,
});
